export const EShapeStrokeStyle = wcardinal.ui.EShapeStrokeStyle;